import React, { useCallback, useEffect, useState } from 'react';
import { useControleAporte } from '.';
import { Period } from '../Dashboard';
import styles from './AportesNecessarios.module.scss';
import { NotFoundMessage } from 'components/elements';
import AporteItem from '../AporteItem';

interface AportesNecessariosProps {
  aportesNecessarios: Period[];
  onAportesChange?: (novosPeríodos: Period[]) => void;
  onDataRefresh?: () => void;
}

const AportesNecessarios: React.FC<AportesNecessariosProps> = ({
  aportesNecessarios,
  onDataRefresh,
}) => {
  const { toggleAporteSelecionado, loading, isAporteSelecionado } =
    useControleAporte(onDataRefresh);
  const [aportesVisiveis, setAportesVisiveis] = useState<Period[]>([]);

  useEffect(() => {
    setAportesVisiveis(aportesNecessarios);
  }, [aportesNecessarios]);

  const handleToggleAporte = useCallback(
    (aporteId: string): boolean => {
      return toggleAporteSelecionado(aporteId);
    },
    [toggleAporteSelecionado]
  );

  if (aportesVisiveis.length === 0) {
    return <NotFoundMessage />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.periodsList}>
        {aportesVisiveis.map(aporte => (
          <AporteItem
            key={aporte.id}
            aporte={aporte}
            onToggle={handleToggleAporte}
            loading={loading}
            isSelected={isAporteSelecionado(aporte.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default AportesNecessarios;
